// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__1LBwh","itemsContainer":"Menu_itemsContainer__2xvY5","link":"Menu_link__r1CI9","active":"Menu_active__1SY83"};